export const FILE_TYPES = {
  boiId: 'BOI_ID',
};
